import styled, { css } from 'styled-components'
import sktDefault from 'src/assets/images/icon_skt.png'
import sktActive from 'src/assets/images/icon_skt_on.png'
import ktActive from 'src/assets/images/icon_kt_on.png'
import lgActive from 'src/assets/images/icon_lg_on.png'
import ktDefault from 'src/assets/images/icon_kt.png'
import lgDefault from 'src/assets/images/icon_lg.png'
import { ButtonStyleType, CertsStyleType } from 'src/types/type'

const PhoneVerificationWrap = styled.div<Omit<CertsStyleType, 'type'>>`
  background-color: ${(props) => props.backgroundColor ?? 'none'};
  border: 3px solid ${(props) => props.borderColor ?? 'none'};
  border-radius: 5px;
  max-width: 458px;
  width: 100%;
  margin: 0 auto;
  @media all and (max-width: 492px) {
    width: 93%;
    margin: 10px auto 17px auto;
  }
`
const TelSelectorWrap = styled.div`
  display: flex;
  max-width: 420px;
  width: 100%;
  height: 58px;
  margin: 20px auto;
  @media all and (max-width: 492px) {
    width: 93%;
  }
`

const Telecoms = styled.button<{ bgActive: boolean; actColor: string; oneTelStyle: boolean }>`
  cursor: pointer;
  max-width: ${(props) => (props.oneTelStyle ? 'none' : '140px')};
  width: 100%;
  height: 58px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: auto 30px;
  background-color: #fff;
  border: 1px solid #bbb;
  &.skt {
    background-size: auto 35px;
    background-image: url(${sktDefault});
  }
  &.kt {
    background-image: url(${ktDefault});
  }
  &.lg {
    background-image: url(${lgDefault});
  }

  ${(props) =>
    props.bgActive &&
    css`
      border: 3px solid ${props.actColor};

      &.skt {
        background-size: auto 35px;
        background-image: url(${sktActive});
      }

      &.kt {
        background-image: url(${ktActive});
      }

      &.lg {
        background-image: url(${lgActive});
      }
    `}
`
const TelPhoneNumWrap = styled.div`
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
  display: block;
  @media all and (max-width: 492px) {
    width: 93%;
  }
  > section {
    display: flex;
    gap: 24px;
    > span {
      color: red;
      font-size: 17px;
      line-height: 62px;
    }
  }
`

const TelInput = styled.input<{ borderColor: string, backgroundColor: string }>`
  width: 100%;
  height: 62px;
  padding: 20px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 5px;
  border: 1px solid #b3b3b3;
  font-size: 16px;
  margin-bottom: 15px;
  &:focus {
    background-color: #faffbd;
    border: none;
    outline: 1px solid ${(props) => props.borderColor};
  }
`

const CertInput = styled.input`
  max-width: 330px;
  width: 100%;
  height: 62px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #b3b3b3;
  font-size: 16px;
  margin-bottom: 15px;
  &:focus {
    background-color: #faffbd;
    border: none;
    outline: 1px solid rgb(255, 41, 66);
  }
`
const CertSubmitBtn = styled.button<ButtonStyleType>`
  cursor: pointer;
  width: 100%;
  height: 54px;
  background: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
  margin: 0 0 10px 0;
  color: ${(props) => props.fontColor ?? '#fff'};
  padding: 0;
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  letter-spacing: ${(props) => props.letterSpacing};
`

export {
  TelSelectorWrap,
  Telecoms,
  TelPhoneNumWrap,
  TelInput,
  CertInput,
  CertSubmitBtn,
  PhoneVerificationWrap,
}
